import { render } from "./ConfigManualCopyPaste.vue?vue&type=template&id=77b05192"
import script from "./ConfigManualCopyPaste.vue?vue&type=script&lang=ts"
export * from "./ConfigManualCopyPaste.vue?vue&type=script&lang=ts"

import "./ConfigManualCopyPaste.vue?vue&type=style&index=0&id=77b05192&lang=scss"
script.render = render

export default script